import getEnv from "./getEnv";
export default {
  baseURL: getEnv("VUE_APP_BASE_URL"),
};
